import R_Message from './message';
var Message = new R_Message();
export default Message;
